import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8feba12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "マイクロチップ検索結果", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "マイクロチップ番号", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "品種", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "お名前", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "遺伝子検査ID", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "unregistered"
}

import { useDogStore } from "@/stores/dog";
import { home, female, male } from "ionicons/icons";
import useToastAlert from "@/composables/tostController";
import { useLoadingController } from "@/composables/loadingController"
import axios from "axios";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  alertController
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MicrochipResultView',
  setup(__props) {

const dog = useDogStore()
const { presentLoading, dismissLoading } = useLoadingController();

function deleteDogGeneticId() {
  presentLoading('削除中...')
  const url = `https://api-bleeder-app-test.anicom-pafe.com/v1/microchip/delete/${dog.microchipId}`;
    axios
      .get(url, {timeout: 10000})
        .then((res) => {
          dismissLoading()
          dog.geneticId = res.data.genetic_id;
          useToastAlert("success", "[Success] 削除成功");
        })
        .catch(() => {
          dismissLoading()
          useToastAlert("danger", "削除が失敗しました。");
        })
}

const showConfirmDialog: any = async () => {
  const alert = await alertController.create({
    header: "確認",
    subHeader: dog.geneticId,
    message: `この遺伝子検査IDを削除しますか？`,
    buttons: [
      {
        text: "キャンセル",
        role: "cancel",
      },
      {
        text: "削除",
        role: "confirm",
        handler: () => {deleteDogGeneticId()},
      },
    ],
  });
  await alert.present();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "end",
                "router-link": "/microchip/input",
                "router-direction": "root"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    color: "primary",
                    size: "large",
                    icon: _unref(home)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("生体管理システム（β）")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(IonList), { id: "result-list" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(_unref(dog).microchipId), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createElementVNode("p", null, _toDisplayString(_unref(dog).animalKind), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_unref(dog).animalNameSuffix) + " ", 1),
                          (_unref(dog).isMale())
                            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 0,
                                class: "gender-icon gender-icon-male",
                                icon: _unref(male)
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 1,
                                class: "gender-icon gender-icon-female",
                                icon: _unref(female)
                              }, null, 8, ["icon"]))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        (_unref(dog).hasGeneticId())
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(dog).geneticId), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_8, "未採取"))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!_unref(dog).hasGeneticId())
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  size: "large",
                  expand: "block",
                  onClick: _cache[0] || (_cache[0] = ()=> _ctx.$router.push({name: 'geneticIdInput'}))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("遺伝子検査IDを登録する")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(dog).hasGeneticId())
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 1,
                  color: "danger",
                  size: "large",
                  expand: "block",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmDialog()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("遺伝子検査IDを削除する")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonButton), {
              color: "success",
              size: "large",
              expand: "block",
              "router-link": "/microchip/input",
              "router-direction": "back"
            }, {
              default: _withCtx(() => [
                _createTextVNode("再検索")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})